<template>
  <div>
    <b-card class="md-3">

             <!-- Tabla con la lista de dispositivos-->
                <b-card-text class="userTable">
                  <div>
                    <vue-good-table
                      :columns="columns"
                      :rows="rows"
                      :search-options="{
                      enabled: true,
                      //trigger: 'enter',
                      skipDiacritics: true,
                      //searchFn: mySearchFn,
                      placeholder: 'Buscar en la tabla',
                      //externalQuery: searchQuery
                     }"
                     :pagination-options="{
                         enabled: true,
                         mode: 'records',
                         perPage: 10,
                         dropdownAllowAll: false,
                         //setCurrentPage: 2,
                         nextLabel: '',
                         prevLabel: '',
                         rowsPerPageLabel: 'Filas por pagina',
                         ofLabel: 'de',
                         pageLabel: 'pagina', // for 'pages' mode
                         allLabel: 'Todas',
                       }">

                       <template slot="table-row" slot-scope="props">
                         <span v-if="props.column.field == 'acciones'">
                             <a href="#content" style="color: #606266 !important;">
                               <span style="margin-right:10px;" @click="editRow(props.row.id)">
                                 <i class="far fa-edit fa-lg" style="cursor:pointer"></i>
                               </span>
                             </a>
                               <span @click="deleteModalPopup(props.row.id)">
                                 <i class="far fa-trash-alt fa-lg" style="cursor:pointer">
                                 </i>
                               </span>
                         </span>
                       </template>

                       </vue-good-table>
                  </div>
              </b-card-text>

    </b-card>
  </div>
</template>


<script>
// MIRAR EN https://xaksis.github.io/vue-good-table/guide/
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import UserService from "@/services/UserService";


export default {
  name: "users-list",
  data(){
    return {
      user: [],
      currentUser: null,
      currentIndex: -1,
      columns: [
        {
          label: '# ID',
          thClass: 'text-center',
          tdClass: 'text-center',
          field: 'id',
          hidden: true
        },
        {
          label: 'NIF / CIF',
          field: 'dniuser',
          type: 'string',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Nombre',
          field: 'nombreuser',
          thClass: 'text-center',
          tdClass: 'text-center',
          type: 'string'
        },
        {
          label: 'Apellidos',
          field: 'apellidosuser',
          thClass: 'text-center',
          tdClass: 'text-center',
          type: 'string'
        },
        {
          label: 'Telefono',
          field: 'telefonouser',
          thClass: 'text-center',
          tdClass: 'text-center',
          type: 'string'
        },
        {
          label: 'Email',
          field: 'emailuser',
          thClass: 'text-center',
          tdClass: 'text-center',
          type: 'string'
        },
        {
          label: 'Rol',
          field: 'roluser',
          thClass: 'text-center',
          tdClass: 'text-center',
          type: 'string'
        },
        {
          label: 'Estado',
          field: 'estadouser',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Última modificación',
          thClass: 'text-center',
          tdClass: 'text-center',
          field: 'fechaactualizacionuser'
        },
        {
          label: 'Acciones',
          thClass: 'text-center',
          tdClass: 'text-center',
          field: 'acciones'
        }
      ],
      rows: [ ]
    };
  },
  components: {
    VueGoodTable
  },
  methods: {
    retrieveUsers() {
      UserService.getAll()
        .then(response => {
          this.user = response.data;
          //Cuidado esto puede cortar el lleado del array
          //en caso de que no exista algún campo
          this.populateRows();
        })
        .catch(e => {
          console.log(e);
        });
    },

    refreshList() {
      this.rows = []
      this.retrieveUsers();
    },

    deleteUser(iduser) {
      UserService.delete(iduser)
        .then(response => {
          let texto = 'Se ha eliminiado 1 usuario'
          //Mostrar mensaje
          this.$notify({
             group: 'notificateDiv',
             type: 'pepito',
             title: 'Usuario eliminado correctamente',
             text: texto,
             duration: 3000,
             speed: 1000
          });
          //Quitar del array caragdo la Fila
          this.refreshList();
          //Refrescar tabla
        })
        .catch(e => {
          console.log(e);
        });
    },

    populateRows(){
      //Create struct before insert it
      let newData = null;
      //Add to array
      for (let i = 0; i < this.user.length; i++) {
         //Fill the struct
          newData = {
             id: this.user[i]._id,
             dniuser: this.user[i].nif,
             nombreuser: this.user[i].name,
             apellidosuser:  this.user[i].surname,
             telefonouser: this.user[i].phone,
             emailuser: this.user[i].email ? this.user[i].email : "No asociado",
             roluser: this.user[i].role ? this.user[i].role.alias : " - ",
             estadouser: this.user[i].status ? "Activo" : "Inactivo",
             fechaactualizacionuser: this.$moment(String(this.user[i].updatedAt)).local().format('DD/MM/YYYY HH:mm:ss'),
             /*Be carefull -> inverted quote to multiple html lines -> Now as slot*/
             /*acciones: ''*/
           };
           //Push the data to the array
          this.rows.push(newData)
      }
    },

    editRow(iduser){
      //Emit from child to parent idnodo to be modified
      this.$emit('rowedit', iduser)
    },

    deleteModalPopup(iduser) {
      this.$bvModal.msgBoxConfirm('Recuerde que una vez borrado el usuario no podra ser recuperado de nuevo.', {
        title: '¿Estad usted seguro de borrar el usuario seleccionado del sistema?',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Si, quiero borrarlo',
        cancelTitle: 'No, me he equivocado',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value == true){
            this.deleteUser(iduser);
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
     }
  },
  mounted() {
    this.retrieveUsers();
  }
}
</script>

